/**
 * Ajax Forms - rating
 * ======================================
 * - extend default ajaxForm.js
 */

import $ from "jquery";

$("body").on("submit", ".ajaxForm-rating-product", function(e) {
	var $form = $(this);

	var pros = $form.find('[name="attr_positive[]"]').val();
	var cons = $form.find('[name="attr_negative[]"]').val();
	var message = $form.find('[name="message"]').val();

	var error = $form.find('[name="message"]').data("error");

	if (pros == "" && cons == "" && message == "") {
		alert(error);

		$form.find('[name="message"]').focus();

		e.stopImmediatePropagation();
		e.preventDefault();
	}
});
